import { render, staticRenderFns } from "./reize-frame.vue?vue&type=template&id=48d5033c&"
import script from "./reize-frame.vue?vue&type=script&lang=js&"
export * from "./reize-frame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports